export enum BluetoothTypeEnum {
	NONE = 0,
	MAUI = 1,
	WEB = 2,
	MOUSE = 3,
	POINTER = 4,
	FINGER = 5,
	STYLUS = 6,
}
